import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApplicationContextService {
    private selectedApplicationIdSubject = new BehaviorSubject<number | null>(null);
    public selectedApplicationId$: Observable<number | null> = this.selectedApplicationIdSubject.asObservable();

    constructor() { }
    setSelectedApplicationId(applicationId: number | null): void {
        this.selectedApplicationIdSubject.next(applicationId);
    }

    getSelectedApplicationId(): number | null {
        return this.selectedApplicationIdSubject.value;
    }

    clearSelectedApplication(): void {
        this.selectedApplicationIdSubject.next(null);
    }
}